var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFailedError = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: 20,
  viewBox: "0 0 20 20",
  width: 20,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h20v20h-20z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  stroke: "#333",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m15.5892 5.20494c-1.0128-1.13184-2.3453-1.92952-3.8213-2.28754-1.476-.35801-3.0259-.25947-4.44463.28258-1.41877.54206-2.63953 1.50207-3.50079 2.75305-.86126 1.25097-1.32242 2.73393-1.32248 4.25277v.6275"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.41113 15.2074c1.0127 1.1318 2.34514 1.9294 3.82105 2.2875 1.47589.358 3.02572.2596 4.44452-.2824 1.4187-.5419 2.6395-1.5018 3.5008-2.7527.8613-1.2508 1.3226-2.7336 1.3228-4.2524v-.62415"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.625 11.4558 1.875-1.87499 1.875 1.87499"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.375 8.95581-1.875 1.87499-1.875-1.87499"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10 5.83081v4.99999"
})), /*#__PURE__*/React.createElement("path", {
  d: "m10 13.9583c-.17258 0-.3125-.14-.3125-.3125 0-.1726.13992-.3125.3125-.3125"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10 13.9583c.1726 0 .3125-.14.3125-.3125 0-.1726-.1399-.3125-.3125-.3125"
}))));
export default SvgFailedError;